<script>
import Label from './Label.vue'

export default {
    props: {
        item_key: {
        type: String,
        required: true,
        },
        item_value: {
        type: String,
        required: true,
        },
        item: {
        type: Object,
        required: true,
        },
        submitted: {
        type: Boolean,
        required: true,
        },
        validation: {
        type: Object,
        required: true,
        },
        updateValue: {
            type: Function,
            required: true
        },
        selectedItem: {
        type: Object,
        required: false
        },
    },
    components: {
        Label
    },
    data() {
        return {
            value: this.item_value
        };
    },   
    computed: {
        slug_url() {
            let url = this.item.url.replace('$slug', this.selectedItem.id)
            url = url.replace('$groupId', this.selectedItem.group)
            url = url.replace('//', '/')
            return url;
        }
    },
    watch: {
        item_value: {
            handler(val) {
                this.value = val;
            },
            deep: true
        },
        value(val) {
            this.updateValue(this.item_key, val);
        }
    }
};
</script>
<template>
    <div class="mb-3">
        <Label :item="item" :model_length="validation.$model.length"/>
        <!-- <input
            :value="selectedItem.id"
            :max="item.character_count == 0 ? 10000 : item.character_count"
            :maxlength="item.character_count == 0 ? 10000 : item.character_count"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': submitted && validation.$error, 'bg-soft-secondary': this.$route.params.categoryName == 'globalupdate' ? false 
            : selectedItem.additionalProp1.global ? true : false }"
            :disabled="item.disabled ? true : this.$route.params.categoryName == 'globalupdate' ? false 
            : selectedItem.additionalProp1.global ? true : false"       
            :placeholder="item.placeholder"
        /> -->
          <a :href="`https://${currentPractice.additionalProp1.url}${slug_url}`" target="_blank">
            <p 
              class="ml-auto my-2 font-size-14 font-weight-medium align-self-sm-center">
              {{slug_url}}            
            </p>
          </a>
        <div v-if="submitted && validation.$error" class="invalid-feedback">
        <span v-if="!validation.required">This value is required.</span>
        </div>
    </div>
</template>



